module.exports = __webpack_public_path__ + "dataanalysestatic/img/bg.3cc03ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = Lr6H
// module chunks = 37